export default __webpack_public_path__ + "static/media/music_dark.30d1b085.png";